import { render, staticRenderFns } from "./QcqCompetencePage.vue?vue&type=template&id=1a88b5e4&scoped=true&lang=pug&"
import script from "./QcqCompetencePage.vue?vue&type=script&lang=ts&"
export * from "./QcqCompetencePage.vue?vue&type=script&lang=ts&"
import style0 from "./QcqCompetencePage.vue?vue&type=style&index=0&id=1a88b5e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a88b5e4",
  null
  
)

export default component.exports